import { render, staticRenderFns } from "./ConsignmentPrice.vue?vue&type=template&id=712bcaaa"
import script from "./ConsignmentPrice.vue?vue&type=script&lang=js"
export * from "./ConsignmentPrice.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentPrice.vue?vue&type=style&index=0&id=712bcaaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports